export function dictFilter(val, dictList) {
  if (!dictList) return val
  const dict = dictList.find(el => el.value === val || el.code === val)
  if (dict) {
    return dict.labelDefault
  } else {
    return val
  }
}
